import React from 'react';
import { Tag, Tooltip, Typography } from 'antd';
import { formatKg, parseEngineeringSnapshot } from '@/services/engineeringMaterial.service';

const { Text } = Typography;

interface Props {
  weight: unknown;
  snapshot?: unknown;
}

/** Theoretical weight with the frozen definition / override details on hover. */
export const EngineeringWeightCell: React.FC<Props> = ({ weight, snapshot }) => {
  if (weight == null || weight === '') return <Text type="secondary">—</Text>;
  const snap = parseEngineeringSnapshot(snapshot);
  const overridden = Boolean(snap?.inputs.density_override || snap?.inputs.manual_unit_weight);
  const details = snap ? (
    <div style={{ fontSize: 12 }}>
      <div>
        {snap.definition.item_code} · {snap.definition.profile_code} · {snap.definition.calc_method} · rev {snap.definition.revision}
      </div>
      {snap.definition.grade ? (
        <div>
          {snap.definition.grade.grade_code} · {snap.definition.density_g_cm3} g/cm³
        </div>
      ) : null}
      {snap.definition.section ? (
        <div>
          {snap.definition.section.designation} · {snap.definition.kg_per_m} kg/m
        </div>
      ) : null}
      {snap.result.unit_weight_kg != null ? <div>Unit weight {formatKg(snap.result.unit_weight_kg, 4)}</div> : null}
      {snap.inputs.density_override ? (
        <div>
          Density overridden to {snap.inputs.density_override.value}: {snap.inputs.density_override.reason}
        </div>
      ) : null}
      {snap.inputs.manual_unit_weight ? (
        <div>
          Manual weight {snap.inputs.manual_unit_weight.value} kg: {snap.inputs.manual_unit_weight.reason}
        </div>
      ) : null}
      <div>Formula {snap.definition.formula_revision}</div>
    </div>
  ) : null;
  return (
    <Tooltip title={details}>
      <span>
        <Text>{formatKg(weight)}</Text>
        {overridden ? (
          <Tag color="orange" style={{ marginInlineStart: 4, fontSize: 10 }}>
            override
          </Tag>
        ) : null}
      </span>
    </Tooltip>
  );
};

export default EngineeringWeightCell;
